import { Component } from '@angular/core';
import { NominationProposalDto } from '@models/votes/nomination-proposal.dto';
import { NominationStatus } from '@models/votes/nomination-type.enum';
import { MessageService } from '@services/message.service';
import { NominationService } from '@services/nomination.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-nomination-dialog',
  templateUrl: './nomination-dialog.component.html',
  styleUrls: ['./nomination-dialog.component.scss'],
})
export class NominationDialogComponent {
  public showConfirmation: boolean = false;
  public loaded: boolean = false;

  public nominations: NominationProposalDto[] = [];
  public NominationStatus: typeof NominationStatus = NominationStatus;

  confirming: NominationProposalDto | undefined;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public nominationService: NominationService,
    private messageService: MessageService,
  ) {
    this.loadNominations();
  }

  loadNominations() {
    this.nominationService.getAvailableProposalList().subscribe((result) => {
      this.loaded = true;
      this.nominations = result;
    });
  }

  showConfirm(proposal: NominationProposalDto) {
    this.confirming = proposal;
    this.showConfirmation = true;
  }

  submit(nomination: NominationProposalDto) {
    this.nominationService
      .submitNomination(nomination.proposalId!)
      .subscribe(() => {
        this.messageService.success(
          'Candidatura spontanea',
          'Candidatura spontanea inviata',
        );
        this.showConfirmation = false;
        this.confirming = undefined;
        this.loadNominations();
      });
  }

  cancel() {
    this.showConfirmation = false;
    this.confirming = undefined;
  }
}
